import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useFormNew } from '../../../../../hooks/useFormNew';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { Button, Grid, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";

import moment from 'moment';
import { HCE_PERMISOS } from '../../../../../utils/permisos';
import { AREAS_USUARIOS } from '../../../../../utils/constants';
import { GenericModal } from '../../../../atomic/organisms/GenericModal';
import Title from '../ResumenHCE/Title';
import { validarSoloUnPermiso } from '../../../../../helpers/permisos';
import { VacunasItem } from './VacunasItem';
import { postVacunas, traerVacunas } from '../../../../../actions/hce/hceActions';


export const CardVacunas = ({ hce }) => {

    const { permisos: permisosUser, areas } = useSelector((state) => state.auth);
    const { vacunas, disabled } = useSelector((state) => state.hce);
    const [modal, setModal] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(traerVacunas(hce.idAfiliado, hce.idAfiliadoExterno));
      }, []);

    const initialValues = {
        idAfiliado: hce?.idAfiliado ? hce.idAfiliado : 0,
        idAfiliadoExterno: hce?.idAfiliadoExterno ? hce.idAfiliadoExterno : 0,
        profesional: '',
        establecimiento: '',
        fechaAplicacion: '',
        vacuna: '',
        lote: '',
        esquema: '',
        dosis: '',
        comentario: '',
        idAgenda: hce.idAgenda
    };

    const { formValues, handleInputChange, reset, setearValor } = useFormNew(initialValues);

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(postVacunas({ ...formValues }, setModal));
        reset();
    };

    console.log(vacunas)

    return (
        <>
            <Title>
                Vacunas{' '}
                {validarSoloUnPermiso(
                    permisosUser,
                    HCE_PERMISOS.HCE,
                ) &&
                    areas.filter((area) => area.idArea === AREAS_USUARIOS.CENTROS_MEDICOS)
                        .length > 0 && (
                        <>
                            {!disabled &&
                                <Button
                                    disabled={disabled}
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    onClick={() => {
                                        setModal(true);
                                    }}
                                >
                                    + Ingresar Vacuna
                                </Button>
                            }
                        </>
                    )}
            </Title>
            {Array.isArray(vacunas) && vacunas?.length > 0 ? (
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell style={{ width: '10%' }}>Profesional</TableCell>
                            <TableCell style={{ width: '10%' }}>Establecimiento</TableCell>
                            <TableCell style={{ width: '10%' }}>fechaAplicacion</TableCell>
                            <TableCell style={{ width: '10%' }}>Vacuna</TableCell>
                            <TableCell style={{ width: '10%' }}>
                                Lote
                            </TableCell>
                            <TableCell style={{ width: '10%' }}>
                                Esquema
                            </TableCell>
                            <TableCell style={{ width: '10%' }}>
                                Dosis
                            </TableCell>
                            <TableCell style={{ width: '20%' }}>
                                Comentario
                            </TableCell>

                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {vacunas.map((vacuna, index) => {
                            return (
                                <VacunasItem
                                    key={vacuna?.id.toString()}
                                    vacuna={vacuna}
                                />
                            );
                        })}
                    </TableBody>
                </Table>
            ) : (
                <Typography style={{ fontSize: '1.1rem', fontStyle: 'italic' }}>
                    No hay Vacunas Registradas
                </Typography>
            )}
            {modal && (
                <GenericModal
                    open={modal}
                    closeModal={() => {
                        setModal(false);
                    }}
                    title={'Agregar Vacuna'}
                    gridStyle={{ textAlign: 'center', padding: '1em' }}
                    maxWidth="md"
                >
                    <ValidatorForm onSubmit={handleSubmit}>
                        <Grid container spacing={2}>
                            <Grid item xs={4} sm={4} md={4} lg={4}>
                                <TextValidator
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    label="Profesional"
                                    autoComplete="off"
                                    name="profesional"
                                    value={formValues.profesional}
                                    onChange={handleInputChange}
                                    validators={["required"]}
                                    errorMessages={["Requerido"]}
                                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                                />
                            </Grid>
                            <Grid item xs={4} sm={4} md={4} lg={4}>
                                <TextValidator
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    label="Establecimiento"
                                    autoComplete="off"
                                    name="establecimiento"
                                    value={formValues.establecimiento}
                                    onChange={handleInputChange}
                                    validators={["required"]}
                                    errorMessages={["Requerido"]}
                                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={4} lg={4}>
                                        <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                            <KeyboardDatePicker
                                                margin="normal"
                                                id="dialogFecFin"
                                                label="Fecha Aplicacíon"
                                                format="dd/MM/yyyy"
                                                okLabel="Aceptar"
                                                clearLabel="Limpiar"
                                                cancelLabel="Cancelar"
                                                value={
                                                    moment(formValues.fechaAplicacion).isValid()
                                                        ? moment(formValues.fechaAplicacion)
                                                        : null
                                                }
                                                onChange={(date) => {
                                                    setearValor("fechaAplicacion", date);
                                                }}
                                                KeyboardButtonProps={{
                                                    "aria-label": "change date",
                                                }}
                                                validators={["required"]}
                                                errorMessages={["Requerido"]}
                                            />
                                        </MuiPickersUtilsProvider>
                            
                            </Grid>
                            <Grid item xs={4} sm={4} md={4} lg={4}>
                                <TextValidator
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    label="Vacuna"
                                    autoComplete="off"
                                    name="vacuna"
                                    value={formValues.vacuna}
                                    onChange={handleInputChange}
                                    validators={["required"]}
                                    errorMessages={["Requerido"]}
                                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                                />
                            </Grid>
                            <Grid item xs={4} sm={4} md={4} lg={4}>
                                <TextValidator
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    label="Lote"
                                    autoComplete="off"
                                    name="lote"
                                    value={formValues.lote}
                                    onChange={handleInputChange}
                                    validators={["required"]}
                                    errorMessages={["Requerido"]}
                                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                                />
                            </Grid>
                            <Grid item xs={4} sm={4} md={4} lg={4}>
                                <TextValidator
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    label="Esquema"
                                    autoComplete="off"
                                    name="esquema"
                                    value={formValues.esquema}
                                    onChange={handleInputChange}
                                    validators={["required"]}
                                    errorMessages={["Requerido"]}
                                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                                />
                            </Grid>
                            <Grid item xs={4} sm={4} md={4} lg={4}>
                                <TextValidator
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    label="Dosis"
                                    autoComplete="off"
                                    name="dosis"
                                    value={formValues.dosis}
                                    onChange={handleInputChange}
                                    validators={["required"]}
                                    errorMessages={["Requerido"]}
                                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                                />
                            </Grid>
                            <Grid item xs={8} sm={8} md={8} lg={8}>
                                <TextValidator
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    label="Comentario"
                                    autoComplete="off"
                                    name="comentario"
                                    value={formValues.comentario}
                                    onChange={handleInputChange}
                                    validators={["required"]}
                                    errorMessages={["Requerido"]}
                                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                styles={{
                                    display: 'flex',
                                }}
                            >
                                <Button
                                    variant="outlined"
                                    style={{ marginRight: '1rem' }}
                                    onClick={() => setModal(false)}
                                >
                                    Cancelar
                                </Button>
                                <Button type="submit" variant="contained" color="primary">
                                    Guardar
                                </Button>
                            </Grid>
                        </Grid>
                    </ValidatorForm>
                </GenericModal>
            )}
        </>
    )
}
